exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove-document-dialog-wrapper .delete-dialog-message[data-v-b235abac] {\n  padding: 20px 30px;\n}\n.remove-document-dialog-wrapper .footer[data-v-b235abac] {\n  display: flex;\n  justify-content: flex-end;\n  padding: 17px 20px;\n}\n.remove-document-dialog-wrapper .footer > button[data-v-b235abac]:not(:first-child) {\n  margin-left: 20px;\n}\n", ""]);

// exports
